(() => {
  const CHECKOUT_SELECTOR = 'button[name="checkout"], #checkout, #CartDrawer-Checkout';
  let allowCheckout = false;
  let lastCheckoutButton = null;

  function removeModal() {
    const modal = document.getElementById('GiaboCheckoutUpsell');
    if (modal) modal.remove();
    document.body.classList.remove('giabo-checkout-upsell-open');
    lastCheckoutButton?.focus?.();
  }

  async function fetchFreeShippingSource() {
    try {
      const response = await fetch('/cart?section_id=main-cart-footer', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return null;
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-giabo-free-shipping]');
    } catch (error) {
      console.error('GIABO free shipping source:', error);
      return null;
    }
  }

  async function getSource(button) {
    const scope = button.closest('cart-drawer') ||
      button.closest('cart-notification') ||
      button.closest('.shopify-section') ||
      document;

    return scope.querySelector('[data-giabo-free-shipping]') ||
      document.querySelector('[data-giabo-free-shipping]') ||
      await fetchFreeShippingSource();
  }

  async function addSuggestion(button) {
    const variantId = button?.dataset?.variantId;
    if (!variantId) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = document.documentElement.lang.startsWith('de') ? 'Wird hinzugefügt…' : 'Adding…';

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');

      // Refresh storefront cart UI and the modal content from the server.
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer?.getSectionsToRender) {
        const refresh = new FormData();
        refresh.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id));
        refresh.append('sections_url', window.location.pathname);
      }

      removeModal();
      window.location.reload();
    } catch (error) {
      console.error('GIABO checkout upsell:', error);
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function proceedToCheckout(checkoutButton) {
    allowCheckout = true;
    removeModal();

    if (checkoutButton.form) {
      if (typeof checkoutButton.form.requestSubmit === 'function') {
        checkoutButton.form.requestSubmit(checkoutButton);
      } else {
        checkoutButton.click();
      }
    } else {
      window.location.href = '/checkout';
    }
  }

  function openModal(source, checkoutButton) {
    removeModal();
    lastCheckoutButton = checkoutButton;

    const locale = (document.documentElement.lang || 'de').slice(0, 2);
    const modal = document.createElement('div');
    modal.id = 'GiaboCheckoutUpsell';
    modal.className = 'giabo-checkout-upsell-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'GiaboCheckoutUpsellTitle');

    const panel = document.createElement('div');
    panel.className = 'giabo-checkout-upsell-modal__panel';

    const header = document.createElement('div');
    header.className = 'giabo-checkout-upsell-modal__header';
    header.innerHTML = `
      <div>
        <p class="giabo-checkout-upsell-modal__eyebrow">${locale === 'de' ? 'Fast geschafft' : locale === 'fr' ? 'Presque terminé' : 'Almost there'}</p>
        <h2 id="GiaboCheckoutUpsellTitle" class="giabo-checkout-upsell-modal__title">
          ${locale === 'de' ? 'Kostenlosen Versand sichern' : locale === 'fr' ? 'Profitez de la livraison gratuite' : 'Unlock free shipping'}
        </h2>
      </div>
      <button type="button" class="giabo-checkout-upsell-modal__close" aria-label="${locale === 'de' ? 'Schließen' : 'Close'}">×</button>
    `;

    const cloned = source.cloneNode(true);
    cloned.removeAttribute('role');
    cloned.removeAttribute('aria-live');

    const actions = document.createElement('div');
    actions.className = 'giabo-checkout-upsell-modal__actions';
    actions.innerHTML = `
      <button type="button" class="button button--secondary giabo-checkout-upsell-modal__continue">
        ${locale === 'de' ? 'Trotzdem zur Kasse' : locale === 'fr' ? 'Continuer vers le paiement' : 'Continue to checkout'}
      </button>
    `;

    panel.append(header, cloned, actions);
    modal.appendChild(panel);
    document.body.appendChild(modal);
    document.body.classList.add('giabo-checkout-upsell-open');

    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('.giabo-checkout-upsell-modal__close')) {
        removeModal();
        return;
      }

      const add = event.target.closest('.giabo-shipping-upsell__add');
      if (add) {
        event.preventDefault();
        addSuggestion(add);
        return;
      }

      if (event.target.closest('.giabo-checkout-upsell-modal__continue')) {
        proceedToCheckout(checkoutButton);
      }
    });

    const esc = (event) => {
      if (event.key === 'Escape' && document.getElementById('GiaboCheckoutUpsell')) {
        removeModal();
        document.removeEventListener('keydown', esc);
      }
    };
    document.addEventListener('keydown', esc);

    requestAnimationFrame(() => panel.querySelector('.giabo-checkout-upsell-modal__close')?.focus());
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(CHECKOUT_SELECTOR);
    if (!button) return;

    if (allowCheckout) {
      allowCheckout = false;
      return;
    }

    // Stop the native checkout submit until we know whether the upsell should be shown.
    event.preventDefault();
    event.stopImmediatePropagation();

    const source = await getSource(button);
    if (!source) {
      proceedToCheckout(button);
      return;
    }

    const remaining = Number(source.dataset.remainingCents || 0);
    const suggestion = source.querySelector('.giabo-shipping-upsell__add[data-variant-id]');

    if (remaining <= 0 || !suggestion) {
      proceedToCheckout(button);
      return;
    }

    openModal(source, button);
  }, true);
})();
